import aclMeta, { userTypePageAcl } from '@/router/consts'
import { eCircularRouteNames, directoryRouteNames, standaloneWpRouteNames } from '@/utils/consts'

const userTypeAcl = userTypePageAcl.tenant

const TenantDashboard = () => import('@/pages/dashboards/TenantView')
const TenantAllTenancyRecords = () => import('@/pages/tenants/AllTenancyRecords')

const TenantTermsOfUse = () => import('@/pages/tenants/TermsOfUse')
const TenantPrivacyPolicy = () => import('@/pages/tenants/policyDetail.vue')

const CcdTenancyView = () => import('@/pages/ccd/TenancyView')
const TenancyAllECircular = () => import('@/modules/ccd/tenancy/TenancyAllECircular')
const CcdTenantContacts = () => import('@/modules/contacts/ContactsIndex')
const CcdContactDetail = () => import('@/pages/ccd/ContactDetail')
const Directories = () => import('@/modules/directories/List')
const DirectoryEdit = () => import('@/modules/directories/Edit')
const DirectoryDetail = () => import('@/modules/directories/DetailView')

const HandoverTakeback = () => import('@/modules/hotb/HandoverTakeback')
const CreateTenantProject = () => import('@/modules/tenantProjects/information/CreateTenantProject')
const TenantProject = () => import('@/modules/tenantProjects/TenantProject')

const CreateWorkPermit = () => import('@/modules/workPermits/CreateWorkPermit')
const StandaloneWp = () => import('@/modules/workPermits/StandaloneWp')

const ExternalUserProfile = () => import('@/pages/ExternalUserProfile')

const prefix = '/tenants'

const paths = {
  routes: [
    /**
     * Tenants view
     */
    { path: '/terms-of-use', name: 'tenantTermsOfUse', component: TenantTermsOfUse, meta: { userTypeAcl: () => true, showHeaderFooter: false } },
    { path: '/privacy-policy', name: 'tenantPrivacyPolicy', component: TenantPrivacyPolicy, meta: { userTypeAcl: () => true, showHeaderFooter: false } },
    { path: '/dashboard', name: 'tenantDashboard', component: TenantDashboard },
    { path: '/contacts', name: 'tenantContacts', component: CcdTenantContacts },
    { path: '/ccdcontacts/detail/:id', name: 'tenantCcdContactView', component: CcdContactDetail },
    { path: '/ccdcontacts/create', name: 'tenantCcdContactCreate', component: CcdContactDetail },
    { path: '/ccdcontacts/edit/:id', name: 'tenantCcdContactEdit', component: CcdContactDetail },
    { path: '/tenancies/ecirculars/:id', name: eCircularRouteNames.tenantTenancyECirculars, component: TenancyAllECircular, meta: { acl: aclMeta.tenancyRecordCreateUpdate } },
    { path: '/tenancies/:id', name: 'ccdTenancyTenantView', component: CcdTenancyView, meta: { acl: aclMeta.tenancyRecordCreateUpdate } },
    { path: '/tenancies/:id/directories', name: directoryRouteNames.tenantDirectories, component: Directories },
    { path: '/tenancies/directories/:id', name: directoryRouteNames.tenantDirectoryDetail, component: DirectoryEdit },
    { path: '/tenancies/directories/:id/view', name: directoryRouteNames.tenantDirectoryDetailView, component: DirectoryDetail },
    {
      path: '/allTenancyRecs',
      name: 'tenantAllTenancyRecs',
      component: TenantAllTenancyRecords,
      meta: {
        acl: aclMeta.tenancyRecordCreateUpdate,
      },
    },
    { path: '/handover-takeback/:id', name: 'tenantHandover', component: HandoverTakeback },
    { path: '/tenant-projects/:id', name: 'tenantProjectDetail', component: TenantProject },
    { path: '/tenant-projects/:id/edit', name: 'createTenantProject', component: CreateTenantProject },
    /**
     * Work Permit
     */
    { path: '/work-permits/:id', name: 'tenantCreateWorkPermit', component: CreateWorkPermit },
    { path: '/standalone-wp/:id', name: standaloneWpRouteNames.tenantStandaloneWp, component: StandaloneWp },
    /**
     * Profile
     */
    { path: '/profile', name: 'tenantProfile', component: ExternalUserProfile },
  ],
}

export default { prefix, paths, userTypeAcl }
